import { Slice, Fragment, Node } from 'prosemirror-model';
import store from '@/store/index.js';
import $ from 'jquery';

function pasteParser(editor, e, slice) {
	// Somewhat hacky way of getting current text-block's id
	let blockWrapper = $(editor.dom).closest('.c-block');

	if (blockWrapper.length < 1) {
		// wtf
		return true;
	}

	let blockId = blockWrapper.attr('data-id');

	let newBlocks = [];
	if (slice.content) {
		for (let i = 0; i < slice.content.content.length; i++) {
			newBlocks.push({
				content: {
					html: `<p>${slice.content.content[i].textContent}</p>`
				}
			});
		}
	}

	let payload = {
		blocks: newBlocks,
		insertBlockId: blockId
	};

	store.dispatch('block/addPastedTextBlocks', payload);
	return true;
}

export default pasteParser;
